<template>
  <div id="">
    <div class="emd-stripe">
      <div class="emd-bounds">
        <div class="emd-section fade-in">
          <div v-if="isLoading && !requestFailed" class="emd-box _state_loading-addData"></div>
          <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center">{{$t('edit.error')}}</p>
          <div v-else class="emd-box">
            <EmdBoxHeader :title="$t('breadcrumb.edit.additionalData')">
              <button class="emd-btn _color_secondary _type_text" v-show="disabled" @click="disabled = !disabled">{{$t('edit.edit')}}</button>
            </EmdBoxHeader>
            <div class="emd-box__content">
              <div class="emd-alert _color_success hideFeedback" ref="feedback">
                <p>{{$t('edit.form.additionalData.success_message')}}</p>
              </div>
              <error-list :items="errors"></error-list>
              <div class="emd-flex" >
                <div class="emd-flex-item _basis_12 _basis_6_md">
                  <div class="emd-chunk">
                    <div class="emd-form-group">
                      <label class="emd-label">JSONSCHEMA</label>
                      <div class="emd-chunk" @click="sendFsEvent('dados-adicionais-configuração')">
                        <codemirror :class="['markdown-editor', disabled ? 'disabled' : '']" v-model="body.additional_data" :options="cmOptions"></codemirror>
                      </div>
                      <div class="emd-input-helper" ref="errorFeedback"></div>
                    </div>
                  </div>
                </div>
                <div class="emd-flex-item _basis_12 _basis_6_md">
                  <label class="emd-label ">{{$t('edit.form.additionalData.form')}}</label>
                  <div class="emd-box">
                    <div class="emd-box__content">
                      <form-builder
                        :schema="schemaFormatted"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="emd-flex _justify_flex-end" v-show="!disabled">
                <div class="emd-flex-item _shrink">
                  <button class="emd-btn _color_primary _type_text" type="button" @click="disabled = !disabled">{{$t('edit.cancel')}}</button>
                </div>
                <div class="emd-flex-item _shrink">
                  <button class="emd-btn _color_secondary" type="submit" :disabled="!formIsValid" @click="saveAdditionalData">{{$t('edit.save')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $RefParser from '@apidevtools/json-schema-ref-parser'
import { codemirror } from 'vue-codemirror'
import FormBuilder from '@/components/project/FormBuilder.vue'
import ErrorList from '@/components/project/ErrorList.vue'
import EmdBoxHeader from '@/components/emerald/EmdBoxHeader'
import sendFsCustomEvent from '@/mixins/sendFsCustomEvent'

export default {
  name: 'ApplicationAdditionalData',
  components: {
    codemirror,
    FormBuilder,
    ErrorList,
    EmdBoxHeader
  },
  mixins: [sendFsCustomEvent],
  computed: {
    isLoading () {
      return this.$store.state.application.detail.isLoading
    },
    additionalDataPure () {
      return this.$store.state.application.detail.additional_data
    },
    additionalDataBody () {
      return this.body.additional_data
    }
  },
  watch: {
    additionalDataPure (value) {
      if (value === undefined) {
        this.setBasicSchema()
      } else {
        this.body.additional_data = value
        this.schema = value instanceof Object ? Object.assign({}, value) : JSON.parse(value)
      }
    },
    additionalDataBody (value) {
      if (value === '') this.setBasicSchema()
      else this.schema = value instanceof Object ? Object.assign({}, value) : JSON.parse(value)
    },
    schema (value) {
      const schemaCopy = Object.assign({}, value)
      if (schemaCopy.properties.conditional && schemaCopy.properties.conditional.$ref) {
        $RefParser.dereference(value, (err, schema) => {
          if (err) {
            this.schemaFormatted = schemaCopy
          } else {
            const schemaConditional = schema.properties.conditional
            if (schemaConditional.properties) {
              schemaCopy.properties = {
                ...schemaConditional.properties,
                ...schemaCopy.properties
              }
            }
            if (schemaConditional.required) {
              schemaCopy.required = [
                ...schemaConditional.required,
                ...schemaCopy.required
              ]
            }
            if (schemaConditional.dependencies) {
              Object.keys(schemaConditional.dependencies).forEach(item => {
                schemaCopy.properties[item].conditional = schemaConditional.dependencies[item]
              })
            }
            delete schemaCopy.conditional
            this.schemaFormatted = schemaCopy
          }
        })
      } else {
        this.schemaFormatted = schemaCopy
      }
    }
  },
  data () {
    return {
      disabled: true,
      formIsValid: true,
      schema: {
        properties: {}
      },
      schemaFormatted: {
        properties: {}
      },
      cmOptions: {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        theme: 'base16-dark',
        lineNumbers: true,
        line: true
      },
      body: {
        additional_data: undefined
      },
      errors: [],
      requestFailed: false,
      aditionalDataModified: false
    }
  },
  methods: {
    displayMessageJSON (message) {
      if (message !== undefined) {
        this.$refs.errorFeedback.innerHTML = message
        this.$refs.errorFeedback.parentNode.classList.add('_state_error')
        return true
      }
      this.$refs.errorFeedback.innerHTML = ''
      this.$refs.errorFeedback.parentNode.classList.remove('_state_error')
      return true
    },
    displayFeedback () {
      this.$refs.feedback.classList.add('displayFeedback')
      this.$refs.feedback.classList.remove('hideFeedback')
      setTimeout(() => {
        this.$refs.feedback.classList.remove('displayFeedback')
        this.$refs.feedback.classList.add('hideFeedback')
      }, 2000)
    },
    saveAdditionalData (e) {
      if (this.formIsValid) {
        const submitButton = e.target
        submitButton.classList.add('_state_loading')
        this.$store.dispatch('UPDATE_ADDITIONAL_DATA', this.body)
          .then(response => {
            this.errors = []
            this.disabled = true
            submitButton.classList.remove('_state_loading')
            this.displayFeedback()
            this.requestFailed = false
          })
          .catch(response => {
            submitButton.classList.remove('_state_loading')
            if (response.status === 400) {
              this.errors = response.body.errors
            }
          })
      }
    },
    setBasicSchema () {
      const basicSchema = {
        type: 'object',
        properties: {},
        required: []
      }
      this.body.additional_data = JSON.stringify(basicSchema, null, 4)
      this.schema = basicSchema
    }
  },
  created () {
    if (this.additionalDataPure === undefined) {
      this.setBasicSchema()
    } else {
      this.body.additional_data = this.additionalDataPure
      this.schema = this.additionalDataPure instanceof Object ? Object.assign({}, this.additionalDataPure) : JSON.parse(this.additionalDataPure)
    }
  }
}
</script>
<style>
  .CodeMirror {
    padding: 0 !important;
  }
  .markdown-editor.disabled .CodeMirror.cm-s-base16-dark {
    background: #e6ebef;
    pointer-events: none;
  }
  .emd-box._state_loading-addData {
    height: 700px;
    background-repeat: no-repeat;
    background-image: linear-gradient(#f4f4f4), linear-gradient(#f4f4f4), linear-gradient(#f4f4f4), linear-gradient(#f4f4f4), linear-gradient(#f4f4f4);
    background-size:
      125px 25px,
      95px 20px,
      98% 302px,
      95px 20px,
      98% 200px;
    background-position:
      1.5% 3%,
      1.75% 9.5%,
      46% 23%,
      1.75% 65%,
      46% 94%;
    opacity: 1;
    animation: opacity 1s infinite ease-in;
  }
  @media (min-width: 768px) {
    .emd-box._state_loading-addData {
      height: 400px;
      background-size:
        15% 25px,
        8% 20px,
        48% 200px,
        8% 20px,
        48% 200px;
      background-position:
        1.5% 7%,
        1.75% 23%,
        3% 58%,
        55% 23%,
        97.5% 58%;
    }
  }

</style>
